module.exports = __webpack_public_path__ + "faq/img/color.8f41b9cd.png";